<template>
	<div
		:class="{
			fillWidth: fillWidth,
			highlight: highlight,
			container__card: !cardWithoutBackground,
		}"
		@click="$emit('click', $event)"
	>
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		cardWithoutBackground: {
			type: Boolean,
			default: false,
		},
		fillWidth: {
			type: Boolean,
			default: false,
		},
		highlight: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scped>
.container__card {
	height: auto;
	width: auto;
	background-color: white;
	border-radius: 2px;
	border: 1px solid #e6e6e6;
	box-shadow: 0px 9px 15px -15px rgba(0, 0, 0, 0.2);
}

.container__card.highlight {
	border: 1px solid #95bb49;
}

.container__card.fillWidth {
	width: 100% !important;
}
</style>
